<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('About to expire (Dashboard about to expire widget title) - About to expire') }}</h4>
  </div>
  <div class="card-body">
    @for(aboutToExpire of (fetchAboutToExpire | async); track aboutToExpire){
      <div class="transaction-item">
        <div class="media align-items-center">
          <div class="avatar bg-light-warning rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-alert-circle"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/documents']" [state]="{query:aboutToExpire.document_number, document_id:aboutToExpire.id}">{{aboutToExpire.name}}</a></h6>
            <p class="text-muted font-small-3 mb-0">{{ aboutToExpire?.document_type?.document_type }} - {{ aboutToExpire?.recipient_roles[0]?.user?.name }}</p>
          </div>
        </div>
      </div>
    } @empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
      </div>
    }
  </div>
</ng-container>